module.exports = {"id":"147779","name":"Vladimir Bystrov","rating":"72","photo":"./data/images/photos/3/147779.png","club":{"name":"FC Tosno","logo":"./data/images/clubs/FCTosno.png"},"positions":["AD","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VladimirBystrov0.json
// module id = 4296
// module chunks = 0